<script lang="ts">
  import { onMount, type Snippet } from 'svelte';
  import { flipOver } from '~/animations.svelte';

  type Props = {
    // changing the key flips the content over (old content out, new content in)
    key: string | boolean | number;
    i: number;
    j: number;
    stagger: number;
    // animate flips caused by `key` changing after mount
    enabled?: boolean;
    // animate the flip-in when first mounted (defaults to `enabled`)
    reveal?: boolean;
    children: Snippet;
  };
  const {
    i = 0,
    j = 0,
    stagger = 0,
    enabled = true,
    reveal = enabled,
    ...props
  }: Props = $props();

  // The first keyed block's intro is the reveal; later blocks come from `key` changes.
  let mounted = $state(false);
  onMount(() => {
    mounted = true;
  });
</script>

{#key props.key}
  <div
    class="flip"
    in:flipOver|global={{
      enabled: mounted ? enabled : reveal,
      intro: true,
      delay: stagger * (i + j),
    }}
    out:flipOver={{
      enabled,
      intro: false,
      delay: stagger * (i + j),
    }}
  >
    {@render props.children()}
  </div>
{/key}

<style>
  .flip {
    grid-row: 1/2;
    grid-column: 1/2;
  }
</style>
